import type { Compliance } from '@pp/core/src/api/fetchers/playerConfig/types';
import type { RtpType } from '@pp/core/src/api/fetchers/rtp/types';
import { MapContextToStore } from '@pp/core/src/components/help/context/mapStateToHelpContextProps';
import type { ChipValueType } from '@pp/core/src/store/slices/chips/types';

export interface ContextToStoreMap {
  gameResult: {
    chips: ChipValueType[];
  };
  howToPlay: {
    chips: ChipValueType[];
    compliance: Compliance | null;
  };
  returnToPlayer: {
    rtp: RtpType | null;
  };
}

export const mapContextToStore: MapContextToStore<ContextToStoreMap> = (state) => ({
  gameResult: {
    chips: state.chips.chips,
  },
  howToPlay: {
    chips: state.chips.chips,
    compliance: state.config.compliance ?? null,
  },
  returnToPlayer: {
    rtp: state.config.rtp,
  },
});
